var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHappyfox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 30,
  viewBox: "0 0 28 30"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC300",
  d: "M13.784 29.929.022 19.676v-5.123l7.923 1.791 5.845 8.155 5.835-8.155 7.924-1.791h.002v5.123z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D00",
  d: "M.022 2.628v11.925h.002l13.76-7.762S3.475.774 2.592.42C.935-.257.021-.357.021 2.628Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF4F00",
  d: "M24.98.42c-.882.354-11.164 6.353-11.164 6.353L.024 14.553l7.923 1.79 5.837 8.156 5.847-8.155 7.92-1.791V2.628c0-2.985-.913-2.885-2.57-2.209Z"
}))));
export default SvgHappyfox;